import React, { useEffect, useState } from "react";
import "./Banner.css";
import axios from "axios";
import { Link } from "react-router-dom";

import { Swiper, SwiperSlide } from "swiper/react";
import "swiper/css";
import "swiper/css/pagination";

import { Pagination } from "swiper/modules";
import DownArrow from "./Animation/DownArrow";

function Banner() {
  const [data, setData] = useState([]);

  const GetEditData = async () => {
    try {
      const response = await axios.get(
        process.env.REACT_APP_BASE_URL + "/v1/mobile/home/banner"
      );

      setData(response?.data?.data || []);
    } catch (error) {
      console.log(error);
    }
  };

  useEffect(() => {
    GetEditData();
  }, []);

  return (
    <section className="home_banner_sec">
      <div className="container">
        <div className="slider_main">
          <Swiper
            spaceBetween={30}
            pagination={{
              clickable: true,
            }}
            modules={[Pagination]}
            className="mySwiper"
          >
            {/* Dynamic Images */}
            {data?.map((val, index) => (
              <SwiperSlide key={index}>
                <div className="sliderdiv">
                  <img
                    className="bannerimg"
                    src={
                      process.env.REACT_APP_IMAGE_URL +
                      val?.website_image
                    }
                    alt="banner-img"
                  />
                </div>
              </SwiperSlide>
            ))}

            {/* Static Image */}
            <SwiperSlide>
              <div className="sliderdiv">
                <img
                  className="bannerimg"
                  src="/assets/images/home/banner/banner.png"
                  alt="static-banner"
                />
              </div>
            </SwiperSlide>
          </Swiper>

          {/* Download Button */}
          <div className="downloadbtnsec">
            <Link
              target="_blank"
              to="https://play.google.com"
            >
              <img
                src={
                  process.env.PUBLIC_URL +
                  "/assets/images/icons/googleplay.png"
                }
                alt="google-play"
              />
            </Link>
          </div>

          {/* Down Arrow */}
          <div className="downarrowalign">
            <DownArrow />
          </div>
        </div>
      </div>
    </section>
  );
}

export default Banner;